const query = ({ product_id, promotion_code, updateState, changeLoading, endpoint_url }) => {
    fetch(`${endpoint_url}?product_id=${product_id}&promotion_code=${promotion_code}`)
        .then((res) => {
            console.log('res', res);
            return res.json();
        })
        .then((res) => {
            console.log('Er', res);
            let response = { ...res };
            if (response.discount_price) {
                response.successMessage = 'Promo code applied';
            }

            updateState(response);
            changeLoading(false);
        })
        .catch((err) => {
            console.log(err);
            changeLoading(false);
        });
};

export default query;

export const getPlans = ({ product_id }) => {
    return fetch(`/customers/discount-coupon-code/?plan_id=${product_id}`);
};

export const getPlansCoupon = ({ product_id, promotion_code }) => {
    return fetch(
        `/customers/discount-coupon-code/?plan_id=${product_id}&promotion_code=${promotion_code}`,
    );
};
